import { TextInput, Stack, Paper, Title, Textarea } from '@mantine/core';

interface EditableFieldProps {
    label: string;
    value: any;
    onChange: (value: any) => void;
    path: string[];
}

const EditableField = ({ label, value, onChange, path }: EditableFieldProps) => {
    if (typeof value === 'object' && value !== null) {
        return (
            <Paper p="md" withBorder>
                <Title order={4} mb="md">{label.charAt(0).toUpperCase() + label.slice(1)}</Title>
                <Stack>
                    {Object.entries(value).map(([key, val]) => (
                        <EditableField
                            key={key}
                            label={key.charAt(0).toUpperCase() + key.slice(1)}
                            value={val}
                            onChange={(newValue) => {
                                const newObj = { ...value };
                                newObj[key] = newValue;
                                onChange(newObj);
                            }}
                            path={[...path, key]}
                        />
                    ))}
                </Stack>
            </Paper>
        );
    }
    if (label === 'Description') {
        return (
            <Textarea
                label={label}
                value={value}
                resize="vertical"
                autosize
                onChange={(e) => onChange(e.target.value)}
                placeholder={`Enter ${label.toLowerCase()}`}
            />
        );
    }
    return (
        <TextInput
            label={label}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={`Enter ${label.toLowerCase()}`}
        />
    );
};

export default EditableField;